import { ITableAdapter } from '../../../../../../generic/universal-table/types/adapter.types'
import {
  PalletApiRow,
  PalletCreatePayload,
  PalletUiRow,
  PalletUpdatePayload,
} from '../types/palletTable.types'

export const palletTableAdapter: ITableAdapter<
  PalletApiRow,
  PalletUiRow,
  PalletCreatePayload,
  PalletUpdatePayload
> = {
  fromApi: (row: PalletApiRow): PalletUiRow => ({
    Pallete_Type: row.Pallete_Type,
    Pallete_Desc: row.Pallete_Desc?.trim() ?? '',
    SupplierID: row.SupplierID ?? 0,
    Main_PalleteID: row.Main_PalleteID ?? 0,
    Accessory1: row.Accessory1 ?? 0,
    Accessory2: row.Accessory2 ?? 0,
    Accessory3: row.Accessory3 ?? 0,
    Catalog_Number: row.Catalog_Number?.trim() ?? '',
    Pallete_Price: row.Pallete_Price ?? 0,
    Real_Pallete: row.Real_Pallete ?? 0,
    Tare_Weight: row.Tare_Weight ?? 0,
    Cooling_Fee: row.Cooling_Fee ?? 0,
    Usage_Fee: row.Usage_Fee ?? 0,
    Active: row.Active ?? false,
    DepositWithVAT: row.DepositWithVAT ?? false,
    Download_from_Warehouse: row.Download_from_Warehouse ?? false,
    Growers_Pallete: row.Growers_Pallete ?? false,
    Inventory: row.Inventory ?? false,
    Transportation_Fee: row.Transportation_Fee ?? false,
    Tranzit_Fee: row.Tranzit_Fee ?? false,
  }),

  toCreatePayload: ({
    Pallete_Type: _,
    ...rest
  }: PalletUiRow): PalletCreatePayload => rest,

  toUpdatePayload: ({
    Pallete_Type: _,
    ...rest
  }: PalletUiRow): PalletUpdatePayload => rest,

  getRowId: (row: PalletUiRow): number => row.Pallete_Type,
}
